import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { TranslateService } from 'ng2-translate/ng2-translate';

import { ActivatedRoute, Router,NavigationStart } from '@angular/router';
import 'rxjs/Rx';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { forgotPasswordService } from '../../_services/userservice/user.forgotpassword.service';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { usercommonattribute } from '../../_services/userservice/user.common.service';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';
export class CustomModalContext extends BSModalContext {}

@Component({
  moduleId: module.id,
  selector: 'app-forget-password',
  providers: [forgotPasswordService, AlertService],
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  public wrongAnswer: boolean;
  model: any = {};
  loading = false;

  appSettings: any;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    private usercommon: usercommonattribute,
    public modal: Modal,
    public fgttPassword: forgotPasswordService,
    private alertService: AlertService,
    public utilserv: utilityService,
    private vcRef: ViewContainerRef,
    private translate: TranslateService,

  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.context = dialog.context;
    this.appSettings = AppSettings;

  }

  forgotClick() {
    this.utilserv.busy = this.fgttPassword.ForgotPassword(this.model.email).subscribe(data => { 
      const responseJson: any = data;
      if (responseJson.Envelope.Body.ForgotPasswordResponse.StatusCode == -10000) {
        this.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('Message_errorMessage'));
        return;
      } else if (responseJson.Envelope.Body.ForgotPasswordResponse.StatusCode == enumStatusCodeList.UserNotFound) {
        this.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('ForgotPasswordPopup_lblEmailNotRegistered'));
        return;
      } else if (responseJson.Envelope.Body.ForgotPasswordResponse.StatusCode == enumStatusCodeList.SUCCESS || responseJson.Envelope.Body.ForgotPasswordResponse.StatusCode == enumStatusCodeList.SUCCESS_FOR_VERIFICATION) {
        this.usercommon.email = this.model.email;
        this.usercommon.UserID = responseJson.Envelope.Body.ForgotPasswordResponse.UserID;
        this.usercommon.dobflag = responseJson.Envelope.Body.ForgotPasswordResponse.StatusDOB;
        this.usercommon.tranflag = responseJson.Envelope.Body.ForgotPasswordResponse.StatusTransaction;
        this.dialog.close();
        this.openResetPassword();
      } else {
        this.openErrorAlert(this.translate.instant('Common_lblOops'), responseJson.Envelope.Body.ForgotPasswordResponse.StatusMessage);
        console.log(responseJson.Envelope.Body.ForgotPasswordResponse.StatusMessage);
      }
    });
  }
  closePopup() {
    this.dialog.close();
  }
  openResetPassword() {
    return this.modal.open(ResetPasswordComponent, overlayConfigFactory({}, BSModalContext));
  }
  openErrorAlert(title, msg) {
    const modalData: any = {};
    modalData.Title = title;
    modalData.Message = msg;
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
  ngOnDestroy() {
    this.closePopup()
  }
}



// WEBPACK FOOTER //
// ./src/app/user/forget-password/forget-password.component.ts